import React from 'react';
import './MarkdownRenderer.css';

// Simple markdown renderer for common formatting
export default function MarkdownRenderer({ content }) {
  if (!content) return null;

  // Convert markdown to JSX
  let html = content;
  
  // Headers (must run BEFORE line breaks conversion)
  html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');
  
  // Lists (must run BEFORE line breaks conversion)
  html = html.replace(/^\* (.+)$/gm, '<li>$1</li>');
  html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');
  
  // Bold text: **text** or __text__
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__(.*?)__/g, '<strong>$1</strong>');
  
  // Italic text: *text* or _text_
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
  html = html.replace(/_(.*?)_/g, '<em>$1</em>');
  
  // Inline code: `code`
  html = html.replace(/`([^`]+)`/g, '<code class="inline-code">$1</code>');
  
  // Links: [text](url) — only render if URL is an absolute https/http link
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, text, url) => {
    if (isSpecificHttpUrl(url)) {
      return `<a href="${url.trim()}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    }
    // Bare domain or relative path — show text only, no link
    return text;
  });
  
  // Line breaks (must run LAST for block elements)
  html = html.replace(/\n/g, '<br />');

  // Remove extra breaks directly after headers
  html = html.replace(/(<\/h[1-3]>)\s*<br \/>/g, '$1');

  // Remove extra breaks directly before headers
  html = html.replace(/<br \/>\s*(<h[1-3]>)/g, '$1');
  
  return (
    <div 
      className="markdown-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

function isSpecificHttpUrl(url) {
  try {
    const parsed = new URL(url.trim());
    return /^https?:$/i.test(parsed.protocol) && parsed.pathname.replace(/\/+$/, '').length > 0;
  } catch {
    return false;
  }
}
